import React, { useCallback, useState } from "react"
import { Link } from "react-router-dom"

import { Formik, Form } from "formik"
import { Fieldset } from "components"

import * as yup from "yup"

import { useAuth } from "hooks/useAuth"

const passwordForgotModel = {
  email: "",
}

const passwordForgotSchema = yup.object().shape({
  email: yup
    .string()
    .email("Please provide valid email address")
    .required("Email is required!"),
})

const Page = ({ children }) => (
  <div className="w-full min-h-screen flex justify-center items-center">
    {children}
  </div>
)

const PasswordForgotPage = () => {
  const { forgotPassword } = useAuth()
  const [isSubmitted, setIsSubmitted] = useState(false)

  const formikProps = {
    initialValues: { ...passwordForgotModel },
    validateOnBlur: false,
    validateOnChange: false,
    validationSchema: passwordForgotSchema,
    onSubmit: useCallback(async (values, { setSubmitting }) => {
      try {
        setSubmitting(true)
        await forgotPassword(values.email)
        setIsSubmitted(true)
      } catch (e) {
        setSubmitting(false)
        console.error("Error", e)
        // const errors = e.graphQLErrors.map(v => v)
        // setFieldError("server", errors)
      }
    }),
  }

  return (
    <Page>
      {isSubmitted ? (
        <div className="max-w-sm mx-auto bg-white shadow-lg p-6 relative z-50">
          <p>
            Please check your email for further instructions. Sometimes spam
            filters block automated emails. If you do not find the email in your
            inbox, please check your spam filter or bulk email folder.
          </p>
        </div>
      ) : (
        <Formik {...formikProps}>
          {({ errors, isSubmitting }) => (
            <Form className="w-full h-full">
              <div className="max-w-sm mx-auto bg-white shadow-lg p-6 py-10 relative z-50 rounded-lg">
                <header className="text-center mb-6">
                  <h1 className="text-xl text-gray-900 leading-none">
                    Forgot your password?
                  </h1>

                  <p className="text-sm text-gray-500 leading-normal mt-2">
                    Enter your email, and we'll send you the reset link
                  </p>
                </header>

                <div className="py-3">
                  <Fieldset
                    name="email"
                    label="Email"
                    type="email"
                    // placeholder="Enter trip name"
                    // max={50}
                  />
                </div>

                <div class="flex items-center justify-between pb-3">
                  <div class="flex items-center">
                    {/* <input
                    id="remember_me"
                    name="remember_me"
                    type="checkbox"
                    class="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
                  />
                  <label
                    for="remember_me"
                    class="ml-2 block text-sm text-gray-900"
                  >
                    Remember me
                  </label> */}
                  </div>

                  <div class="text-sm">
                    <Link
                      to="/login"
                      className="font-medium text-indigo-600 hover:text-indigo-500"
                    >
                      Go back to login
                    </Link>
                  </div>
                </div>

                {errors && errors.server && (
                  <div className=" text-sm error bg-red-200 text-red-800 p-2 mt-2">
                    {errors.server}
                  </div>
                )}

                <button
                  disabled={isSubmitting}
                  // type="submit"
                  className="mt-6 group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                >
                  Send Reset Link
                </button>
              </div>
            </Form>
          )}
        </Formik>
      )}

      <div className="absolute inset-0">
        <img
          className="w-full h-full object-cover"
          src="/images/s-migaj-Yui5vfKHuzs-unsplash.jpg"
          alt=""
        />
      </div>
    </Page>
  )
}

export default PasswordForgotPage
